import { Component, Input } from "@angular/core";

import { IMenuOption } from "@tylertech/forge";

import { Utilities } from "@tylertech/shared-module";
import { IntentService } from "@tylertech/intents-module";
import { MetadataActionService, MetadataService } from "@tylertech/metadata-module";
import { IMetadataAction } from "@tylertech/tyler-api-types";

import { IWidget } from "./iWidget";

@Component({
    selector: "widget",
    templateUrl: "./widget.tmpl.html",
    styleUrls: ["./widget.component.scss"],
    standalone: false
})
export class WidgetComponent
{
    @Input() widget: IWidget;

    @Input() loaded: boolean;

    constructor(
        private $metadataService: MetadataService,
        private $metadataActionService: MetadataActionService,
        private $intentService: IntentService
    ) { }

    ngOnInit(): void
    {
        this.loadMenuOptions();
    }

    menuOpened(e): void
    {
        e.target.activateFirstOption();
    }

    hasCount(): boolean
    {
        return this.widget.count !== undefined;
    }

    get hasMenu(): boolean
    {
        return this.widget.metadataAction && this.$metadataActionService.HasSubitems(this.widget.metadataAction);
    }

    widgetColor(color: string): string
    {
        switch (color)
        {
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-green":
                return "green";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-magenta":
                return "magenta";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-tylerblue":
                return "tylerblue";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-orange":
                return "orange";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-lightblue":
                return "lightblue";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-gold":
                return "gold";
            // FIXME - why were we hard-coding AngularJs CSS class names in the backend?
            case "md-fill-blue":
                return "blue";
            default:
                return "tylerblue";
        }
    }

    private _menuOptions: IMenuOption[];
    get menuOptions(): IMenuOption[]
    {
        return this._menuOptions;
    }

    loadMenuOptions(): void
    {
        if (this.hasMenu)
        {
            const actionSubItems = this.$metadataActionService.GetSubitems(this.widget.metadataAction);
            this._menuOptions = [];

            for (let i = 0, l = actionSubItems.length; i < l; i++)
            {
                if (this.$metadataActionService.IsHidden(actionSubItems[i], null))
                    continue;
                let disabled = this.$metadataActionService.IsDisabled(actionSubItems[i], null);

                this._menuOptions.push({
                    value: actionSubItems[i].Label,
                    label: this.$metadataService.EvaluateString(actionSubItems[i].Label, null, null),
                    disabled: disabled
                });
                if (!this.$metadataActionService.HasSubitems(actionSubItems[i]))
                    continue;

                const subMenuItems: IMenuOption[] = [];
                const subItems = this.$metadataActionService.GetSubitems(actionSubItems[i]);
                subItems.forEach((x) =>
                {
                    disabled = this.$metadataActionService.IsDisabled(x, null);
                    subMenuItems.push({
                        value: x.Label,
                        label: this.$metadataService.EvaluateString(x.Label, parent, null),
                        disabled: disabled
                    });
                });
                this._menuOptions[i].options = subMenuItems;
            }
        }
    }

    stopTileClick(e): void
    {
        e.stopPropagation();
    }

    keydown(event: KeyboardEvent, widget: IWidget): void
    {
        if (event.key === "Enter" || event.key === " ")
        {
            this.activate(widget);
        }
    }

    activate(e): void
    {
        if (this.widget.metadataAction) this.$metadataActionService.ExecuteAction(null, this.widget.metadataAction);
        else if (this.widget.url && this.widget.url !== "#") window.location.href = this.widget.url;
        else if (this.widget.mime && this.widget.action) this.$intentService.resolve(this.widget.mime, this.widget.action, {});
    }

    menuItemSelected(e): void
    {
        const actionSubItems = this.$metadataActionService.GetSubitems(this.widget.metadataAction);
        let action: IMetadataAction;

        if (!Utilities.IsNullOrUndefined(e.detail.parentValue))
        {
            action = actionSubItems.filter(x => x.Label === e.detail.parentValue)[0].SubmenuActions.filter(x => x.Label === e.detail.value)[0];
        }
        else
        {
            action = actionSubItems.filter(x => x.Label === e.detail.value)[0];
        }

        this.executeAction(action);
    }

    executeAction(action: IMetadataAction): void
    {
        this.$metadataActionService.ExecuteAction(null, action);
    }
}
